export enum OrderState {
  Open = "open",
  Cancelled = "cancelled",
  Closed = "closed",
}
